import { Demographic } from 'typings/demographic'

interface DemographicAddressInfo {
  addressLine2: string
  city: string
  companyName: string
  maskedAccount: string
  postalCode: string
  state: string
}

export const getFullAddress = (
  demographics: Demographic
): DemographicAddressInfo => {
  const { address, lastFourDigitAccountNumber = '', companyName } = demographics
  const { addressLine2, city, postalCode, state: stateName } = address || {}
  return {
    maskedAccount: `•••••••${lastFourDigitAccountNumber}`,
    addressLine2,
    city,
    state: stateName,
    postalCode,
    companyName
  }
}
